import * as React from 'react';
import {Mutator, MutableState} from 'final-form';
import {FormSpy} from 'react-final-form';

export type ErrorList = {
  [x: string]: string;
};

export const setSessionErrors: Mutator = (
  [errors]: any,
  state: MutableState,
) => {
  state.formState.submitErrors = errors;
  state.formState.submitFailed = true;
  state.formState.lastSubmittedValues = state.formState.values;
};

class InitializeInitialErrors extends React.Component<{
  initialErrors?: ErrorList;
  form: {
    mutators: {
      [x: string]: Function;
    };
  };
}> {
  componentDidMount() {
    const {
      initialErrors,
      form: {mutators},
    } = this.props;

    if (
      initialErrors &&
      Object.keys(initialErrors).length &&
      mutators.setSessionErrors
    ) {
      mutators.setSessionErrors(initialErrors);
    }
  }

  render() {
    return null;
  }
}

export default (props: {initialErrors?: ErrorList}) => (
  // @ts-ignore
  <FormSpy {...props} component={InitializeInitialErrors} />
);
